import React from 'react';
import { motion } from 'framer-motion';
import { User } from 'lucide-react';
import { fadeInRight, viewportOnce, transitionMedium } from '../../utils/animations';

/**
 * Teacher Selection Step Component
 */
const TeacherSelect = ({ teachers, t, onSelect }) => {
  return (
    <motion.div
      initial={fadeInRight.initial}
      animate={fadeInRight.animate}
      transition={transitionMedium}
      data-testid="select-teacher-step"
      className="bg-white rounded-2xl shadow-sm p-6"
    >
      <h2 className="text-lg font-semibold text-slate-900 mb-4">{t.selectTeacher}</h2>
      
      {teachers.length === 0 ? (
        <p className="text-slate-500 text-center py-8" data-testid="no-teachers-message">
          {t.noTeachers}
        </p>
      ) : (
        <div className="grid gap-4" data-testid="teacher-list">
          {teachers.map((teacher) => (
            <button
              key={teacher.id}
              onClick={() => onSelect(teacher)}
              data-testid={`teacher-card-${teacher.id}`}
              className="flex items-center gap-4 p-4 border-2 border-slate-200 rounded-xl hover:border-slate-900 transition-colors text-left"
            >
              <div className="w-14 h-14 bg-slate-100 rounded-full flex items-center justify-center flex-shrink-0">
                <User className="w-7 h-7 text-slate-400" />
              </div>
              <div>
                <p className="font-medium text-slate-900">{teacher.name}</p>
                <p className="text-sm text-slate-500">{teacher.email}</p>
              </div>
            </button>
          ))}
        </div>
      )}
    </motion.div>
  );
};

export default TeacherSelect;
